import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PPAuthService } from '../../../../core/services/auth.service';
import { MyBookingsService } from '../../../../core/services/my-bookings.service';
import { Observable, Subscription } from 'rxjs';
import { map, tap, concatMap, concat, first, distinctUntilChanged, skip, filter  } from 'rxjs/operators';
import { Booking } from '../../../../core/models/booking.model';

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})
export class MapPage implements OnInit {

  me2Subscription: Subscription;
  booking$: Observable<Booking>;

  constructor( private route: ActivatedRoute, private authService: PPAuthService,  private myBookingsService: MyBookingsService ) { }

  ngOnInit() {

    this.me2Subscription = this.authService.me2$.subscribe(
      user => {
        if ( user && this.route.snapshot.params.bookingId ) {
          this.booking$ = this.myBookingsService.getBooking$( user.id, this.route.snapshot.params.bookingId ); 
        }
      }
    );

  }


  ngOnDestroy() {
    this.me2Subscription.unsubscribe();
  }


}
